import {Repository} from '@s-ui/domain'
/**
 * @typedef {Object} AdvertisingConfigurationResponse
 * @property {Boolean} brandDayEnabled
 */

/**
 * @interface
 */
export default class AdvertisingRepository extends Repository {
  /**
   * @method
   * @return {Promise<AdvertisingConfigurationResponse | Error>}
   */
  getAdvertisingConfiguration() {
    throw new Error('[AdvertisingRepository#getBannerTopSize] must be implemented')
  }

  /**
   * @method
   * @return {Promise<Object | Error>}
   */
  displayAds() {
    throw new Error('[AdvertisingRepository#displayAds] must be implemented')
  }

  /**
   * @method
   * @return {Promise<Object | Error>}
   */
  getPageData() {
    throw new Error('[AdvertisingRepository#getPageData] must be implemented')
  }
}
